module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAE7SURBVEiJxZdBFsIgDESDFzM3E0+GnmzcQE0pIUnF12xsIZk/UKQlkTMAcL181F8W3S8iehMRpZSyV9MFBVAwDq09AzhvYgAtVZQn+bmrUfMtsISGBCp0NxNnCn1FK7RWghVN1pJ4NdhtQCQsBQ/0i+rsH2DBKXL0t67/OSnMTsAsr+k/tpbhdHSCVk7NayNTDexG733WomhowOofDIT3N0ZoAC+45vKW2wqtIg0UAQuNDR5e5Ti+UNxgAYe52CyBqPFaWyT8spFf+sxbMUfBVrui0VZ73t+cAEcNQO4rkP87u2DZDjcq4pmBGdiTh9Fu6hn9isA3ct9hTtmPYP0dgiu/ZP5loAPPNUPJK8FKUdgEjgcOjrrmzkRB/MRSwuBONA9mQopr7SY0RY3UyzsdT6lE9QMxpfQiR3wAYLwST3S9h2IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close-btn.png
// module id = cetZ
// module chunks = 1